export enum PermissionAction {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  Read = 'Read',
  Full = 'Full',
}
